export enum CampaignStatus {
  'Ongoing' = 'Ongoing',
  'Upcoming' = 'Upcoming',
  'Expired' = 'Expired',
}

export type CampaignRawData = {
  id: number;
  title: string;
  description: string;
  chainId: string;
  tags: { name: string; url: string }[];
  startTime: number;
  endTime?: number;
  cardImageUrl: string;
  cardClickUrl: string;
  buttonTitle: string;
  buttonClickUrl: string;
  showLeadBoard: number;
  leadBoardDes: string;
  status: string;
  isBanner: number;
  bannerOrder: number;
};

export type CampaignData = {
  id: number;
  title: string;
  description: string;
  chainId: number | null;
  tags: {
    url: string;
    name: string;
  }[];
  bannerOrder: number;
  isBanner: boolean;
  status: CampaignStatus;
  period: string;
  button: { title: string; url: string };
  cardUrl: string;
  imgSrc: string;
  startTimestamp: number;
  endTimestamp?: number;
  leaderboardDes: string;
  showLeaderBoard: boolean;
};

export type CampaignLeaderboardDataItem = {
  rank: number;
  address: string;
  value: number;
};
export type CampaignLeaderboardSubData = {
  user?: CampaignLeaderboardDataItem & { complete: boolean };
  rank?: CampaignLeaderboardDataItem[];
};
export type CampaignLeaderboardData = {
  [categoryId in string]: CampaignLeaderboardSubData;
};

export type CampaignsLeaderboardData = {
  [campaignId in number]: CampaignLeaderboardData;
};
type TCampaignStatusInfo = {
  color: string;
  labelI18nKey: string;
  titleIcon: JSX.Element;
};

export const CampaignStatusInfo: {
  [id in CampaignStatus]: TCampaignStatusInfo;
} = {
  [CampaignStatus['Ongoing']]: {
    color: '#14B84B',
    labelI18nKey: 'campaign.status.ongoing',
    titleIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.45635 5.16449C9.17283 4.17286 11.1677 3.7731 13.1338 4.02678C15.0998 4.28046 16.9279 5.17352 18.3364 6.56838C19.745 7.96323 20.6558 9.78252 20.9287 11.746C21 12.2588 20.642 12.7323 20.1292 12.8036C19.6163 12.8749 19.1428 12.5169 19.0715 12.0041C18.8553 10.448 18.1334 9.00613 17.0171 7.90066C15.9008 6.79519 14.452 6.08742 12.8938 5.88636C11.3357 5.68531 9.75465 6.00214 8.39429 6.78804C7.46403 7.32546 6.67224 8.06184 6.07136 8.93752H8.00011C8.51788 8.93752 8.93761 9.35725 8.93761 9.87502C8.93761 10.3928 8.51788 10.8125 8.00011 10.8125H4.52109C4.50688 10.8128 4.49264 10.8128 4.47838 10.8125H4.00011C3.48235 10.8125 3.06261 10.3928 3.06261 9.87502V5.87502C3.06261 5.35725 3.48235 4.93752 4.00011 4.93752C4.51788 4.93752 4.93761 5.35725 4.93761 5.87502V7.32249C5.63237 6.45954 6.48447 5.72596 7.45635 5.16449ZM10.6301 11.505C10.9934 11.1417 11.4863 10.9375 12.0001 10.9375C12.514 10.9375 13.0068 11.1417 13.3701 11.505C13.7335 11.8684 13.9376 12.3612 13.9376 12.875C13.9376 13.3889 13.7335 13.8817 13.3701 14.245C13.0068 14.6084 12.514 14.8125 12.0001 14.8125C11.4863 14.8125 10.9934 14.6084 10.6301 14.245C10.2667 13.8817 10.0626 13.3889 10.0626 12.875C10.0626 12.3612 10.2667 11.8684 10.6301 11.505ZM12.0001 12.8125C11.9835 12.8125 11.9676 12.8191 11.9559 12.8308C11.9442 12.8425 11.9376 12.8584 11.9376 12.875C11.9376 12.8916 11.9442 12.9075 11.9559 12.9192C11.9676 12.9309 11.9835 12.9375 12.0001 12.9375C12.0167 12.9375 12.0326 12.9309 12.0443 12.9192C12.056 12.9075 12.0626 12.8916 12.0626 12.875C12.0626 12.8584 12.056 12.8425 12.0443 12.8308C12.0326 12.8191 12.0167 12.8125 12.0001 12.8125ZM3.87107 12.9464C4.38391 12.8752 4.85742 13.2331 4.92869 13.746C5.14494 15.3021 5.86683 16.7439 6.98314 17.8494C8.09946 18.9549 9.54828 19.6626 11.1064 19.8637C12.6646 20.0647 14.2456 19.7479 15.6059 18.962C16.5362 18.4246 17.328 17.6882 17.9289 16.8125H16.0001C15.4823 16.8125 15.0626 16.3928 15.0626 15.875C15.0626 15.3573 15.4823 14.9375 16.0001 14.9375H19.4792C19.4934 14.9372 19.5076 14.9372 19.5218 14.9375H20.0001C20.5179 14.9375 20.9376 15.3573 20.9376 15.875V19.875C20.9376 20.3928 20.5179 20.8125 20.0001 20.8125C19.4823 20.8125 19.0626 20.3928 19.0626 19.875V18.4276C18.3679 19.2905 17.5158 20.0241 16.5439 20.5855C14.8274 21.5772 12.8325 21.9769 10.8665 21.7233C8.90044 21.4696 7.07235 20.5765 5.66381 19.1817C4.25526 17.7868 3.3444 15.9675 3.07154 14.0041C3.00027 13.4912 3.35823 13.0177 3.87107 12.9464Z"
          fill="var(--text-black, #000)"
        />
      </svg>
    ),
  },
  [CampaignStatus['Upcoming']]: {
    color: '#4D88FF',
    labelI18nKey: 'campaign.status.upcoming',
    titleIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99985 2.9375C7.51761 2.9375 7.93735 3.35723 7.93735 3.875V4.93747H14.0623V3.875C14.0623 3.35723 14.4821 2.9375 14.9998 2.9375C15.5176 2.9375 15.9373 3.35723 15.9373 3.875V4.93747H16.9998C17.7788 4.93747 18.526 5.24696 19.0769 5.79784C19.6278 6.34873 19.9373 7.0959 19.9373 7.87497V11.8618L19.9373 11.875C19.9373 12.3928 19.5176 12.8125 18.9998 12.8125H3.93726V19.875C3.93726 20.1568 4.0492 20.427 4.24845 20.6263C4.44771 20.8255 4.71796 20.9375 4.99976 20.9375H11.7948C12.3125 20.9375 12.7323 21.3572 12.7323 21.875C12.7323 22.3927 12.3125 22.8125 11.7948 22.8125H4.99976C4.22068 22.8125 3.47352 22.503 2.92263 21.9521C2.37174 21.4012 2.06226 20.654 2.06226 19.875V7.87497C2.06226 7.0959 2.37174 6.34873 2.92263 5.79784C3.47352 5.24696 4.22068 4.93747 4.99976 4.93747H6.06235V3.875C6.06235 3.35723 6.48208 2.9375 6.99985 2.9375ZM6.06235 7.875V6.81247H4.99976C4.71796 6.81247 4.44771 6.92441 4.24845 7.12367C4.0492 7.32293 3.93726 7.59318 3.93726 7.87497V10.9375H18.0623V7.87497C18.0623 7.59318 17.9503 7.32293 17.7511 7.12367C17.5518 6.92441 17.2815 6.81247 16.9998 6.81247H15.9373V7.875C15.9373 8.39277 15.5176 8.8125 14.9998 8.8125C14.4821 8.8125 14.0623 8.39277 14.0623 7.875V6.81247H7.93735V7.875C7.93735 8.39277 7.51761 8.8125 6.99985 8.8125C6.48208 8.8125 6.06235 8.39277 6.06235 7.875Z"
          fill="var(--text-black, #000)"
        />
        <path
          d="M18.9373 17.371C18.9373 16.8532 18.5175 16.4335 17.9998 16.4335C17.482 16.4335 17.0623 16.8532 17.0623 17.371V18.875C17.0623 19.1236 17.161 19.3621 17.3368 19.5379L18.3368 20.5379C18.703 20.904 19.2966 20.904 19.6627 20.5379C20.0288 20.1718 20.0288 19.5782 19.6627 19.2121L18.9373 18.4866V17.371Z"
          fill="var(--text-black, #000)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5085 15.3837C15.4345 14.4577 16.6903 13.9375 17.9998 13.9375C19.3094 13.9375 20.5652 14.4577 21.4912 15.3837C22.4171 16.3096 22.9373 17.5655 22.9373 18.875C22.9373 20.1845 22.4171 21.4404 21.4912 22.3663C20.5652 23.2923 19.3094 23.8125 17.9998 23.8125C16.6903 23.8125 15.4345 23.2923 14.5085 22.3663C13.5825 21.4404 13.0623 20.1845 13.0623 18.875C13.0623 17.5655 13.5825 16.3096 14.5085 15.3837ZM17.9998 15.8125C17.1876 15.8125 16.4087 16.1352 15.8343 16.7095C15.26 17.2838 14.9373 18.0628 14.9373 18.875C14.9373 19.6872 15.26 20.4662 15.8343 21.0405C16.4087 21.6148 17.1876 21.9375 17.9998 21.9375C18.8121 21.9375 19.591 21.6148 20.1654 21.0405C20.7397 20.4662 21.0623 19.6872 21.0623 18.875C21.0623 18.0628 20.7397 17.2838 20.1654 16.7095C19.591 16.1352 18.8121 15.8125 17.9998 15.8125Z"
          fill="var(--text-black, #000)"
        />
      </svg>
    ),
  },
  [CampaignStatus['Expired']]: {
    color: 'black',
    labelI18nKey: 'campaign.status.expired',
    titleIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99985 2.9375C7.51761 2.9375 7.93735 3.35723 7.93735 3.875V4.93747H14.0623V3.875C14.0623 3.35723 14.4821 2.9375 14.9998 2.9375C15.5176 2.9375 15.9373 3.35723 15.9373 3.875V4.93747H16.9998C17.7788 4.93747 18.526 5.24696 19.0769 5.79784C19.6278 6.34873 19.9373 7.0959 19.9373 7.87497V11.8618L19.9373 11.875C19.9373 12.3928 19.5176 12.8125 18.9998 12.8125H3.93726V19.875C3.93726 20.1568 4.0492 20.427 4.24845 20.6263C4.44771 20.8255 4.71796 20.9375 4.99976 20.9375H11.7948C12.3125 20.9375 12.7323 21.3572 12.7323 21.875C12.7323 22.3927 12.3125 22.8125 11.7948 22.8125H4.99976C4.22068 22.8125 3.47352 22.503 2.92263 21.9521C2.37174 21.4012 2.06226 20.654 2.06226 19.875V7.87497C2.06226 7.0959 2.37174 6.34873 2.92263 5.79784C3.47352 5.24696 4.22068 4.93747 4.99976 4.93747H6.06235V3.875C6.06235 3.35723 6.48208 2.9375 6.99985 2.9375ZM6.06235 7.875V6.81247H4.99976C4.71796 6.81247 4.44771 6.92441 4.24845 7.12367C4.0492 7.32293 3.93726 7.59318 3.93726 7.87497V10.9375H18.0623V7.87497C18.0623 7.59318 17.9503 7.32293 17.7511 7.12367C17.5518 6.92441 17.2815 6.81247 16.9998 6.81247H15.9373V7.875C15.9373 8.39277 15.5176 8.8125 14.9998 8.8125C14.4821 8.8125 14.0623 8.39277 14.0623 7.875V6.81247H7.93735V7.875C7.93735 8.39277 7.51761 8.8125 6.99985 8.8125C6.48208 8.8125 6.06235 8.39277 6.06235 7.875Z"
          fill="var(--text-black, #000)"
        />
        <path
          d="M18.9373 17.371C18.9373 16.8532 18.5175 16.4335 17.9998 16.4335C17.482 16.4335 17.0623 16.8532 17.0623 17.371V18.875C17.0623 19.1236 17.161 19.3621 17.3368 19.5379L18.3368 20.5379C18.703 20.904 19.2966 20.904 19.6627 20.5379C20.0288 20.1718 20.0288 19.5782 19.6627 19.2121L18.9373 18.4866V17.371Z"
          fill="var(--text-black, #000)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5085 15.3837C15.4345 14.4577 16.6903 13.9375 17.9998 13.9375C19.3094 13.9375 20.5652 14.4577 21.4912 15.3837C22.4171 16.3096 22.9373 17.5655 22.9373 18.875C22.9373 20.1845 22.4171 21.4404 21.4912 22.3663C20.5652 23.2923 19.3094 23.8125 17.9998 23.8125C16.6903 23.8125 15.4345 23.2923 14.5085 22.3663C13.5825 21.4404 13.0623 20.1845 13.0623 18.875C13.0623 17.5655 13.5825 16.3096 14.5085 15.3837ZM17.9998 15.8125C17.1876 15.8125 16.4087 16.1352 15.8343 16.7095C15.26 17.2838 14.9373 18.0628 14.9373 18.875C14.9373 19.6872 15.26 20.4662 15.8343 21.0405C16.4087 21.6148 17.1876 21.9375 17.9998 21.9375C18.8121 21.9375 19.591 21.6148 20.1654 21.0405C20.7397 20.4662 21.0623 19.6872 21.0623 18.875C21.0623 18.0628 20.7397 17.2838 20.1654 16.7095C19.591 16.1352 18.8121 15.8125 17.9998 15.8125Z"
          fill="var(--text-black, #000)"
        />
      </svg>
    ),
  },
};

export const getImgsUrl = (id: string) => {
  return `https://api.synfutures.com/ipfs/v2-config${
    process.env.REACT_APP_API_ENV === 'dev' ? '/dev' : ''
  }/v3/images/${id}.png`;
};

export const getCsvUrl = () => {
  return process.env.REACT_APP_API_ENV === 'dev'
    ? 'https://api.synfutures.com/ipfs/v2-config/dev/v3/campaigns.csv'
    : 'https://api.synfutures.com/ipfs/v2-config/v3/campaigns.csv';
};

export const tagColors = [
  { backgroundColor: '#0AC79A26', color: '#0AC79A', hoverColor: '#FFFFFF', hoverBackgroundColor: '#0AC79A' },
  { backgroundColor: '#EBC80D26', color: '#EBC80D', hoverColor: '#FFFFFF', hoverBackgroundColor: '#EBC80D' },
  { backgroundColor: '#506AF126', color: '#506AF1', hoverColor: '#FFFFFF', hoverBackgroundColor: '#506AF1' },
  { backgroundColor: '#D676E926', color: '#D676E9', hoverColor: '#FFFFFF', hoverBackgroundColor: '#D676E9' },
  { backgroundColor: '#1BB5E526', color: '#1BB5E5', hoverColor: '#FFFFFF', hoverBackgroundColor: '#1BB5E5' },
  { backgroundColor: '#8A75F026', color: '#8975F0', hoverColor: '#FFFFFF', hoverBackgroundColor: '#8975F0' },
  { backgroundColor: '#F24A4A26', color: '#F24A4A', hoverColor: '#FFFFFF', hoverBackgroundColor: '#F24A4A' },
  { backgroundColor: '#85DD4F26', color: '#85DD4F', hoverColor: '#FFFFFF', hoverBackgroundColor: '#85DD4F' },
  { backgroundColor: '#F5A24126', color: '#F5A241', hoverColor: '#FFFFFF', hoverBackgroundColor: '#F5A241' },
  { backgroundColor: '#E9619A26', color: '#E9619A', hoverColor: '#FFFFFF', hoverBackgroundColor: '#E9619A' },
];

export const getTagColor = (i: number) => {
  return tagColors[i % tagColors.length];
};
